import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getCoverageSummaryDashBoardDetails = createAsyncThunk(
  'electronic-tool/get-coverage-summary-dashboard-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/coverage-summary-data-details`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getScenarioBuilderCoverageSummaryData = createAsyncThunk(
  'electronic-tool/scenario-builder/coverage-summary-scenario-one',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v2/electronic-tool/scenario-builder/scenario-exact-mpn-price`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
export const getDetailsPriceTrendData = createAsyncThunk(
  'electronic-tool/scenario-builder/coverage-summary-details-price-trend-analysis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/electronic-tool/price-trend-analysis-list-details`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
export const saveScenarioAsync = createAsyncThunk(
  'electronic-tool/scenario-builder/coverage-summary-save-scenario',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/save-scenario`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSavedScenarioData = createAsyncThunk(
  'electronic-tool/scenario-builder/get-saved-scenario',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/get-scenario`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
